import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from "recharts";

export default function ProfileRadar({ scores, max = 6 }) {
  const data = [
    { axis: "Porteuse", value: scores?.porteuse || 0, full: max },
    { axis: "Suradaptée", value: scores?.suradaptee || 0, full: max },
    { axis: "Éteinte", value: scores?.eteinte || 0, full: max },
    { axis: "Déconnectée", value: scores?.deconnectee || 0, full: max },
  ];
  return (
    <div className="w-full" style={{ height: 360 }}>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="#C49DA6" strokeOpacity={0.4} />
          <PolarAngleAxis
            dataKey="axis"
            tick={{ fill: "#3D2230", fontSize: 13, fontFamily: "Italiana, serif" }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, max]}
            tick={{ fill: "#9A918A", fontSize: 10 }}
            tickCount={4}
            stroke="#EBD1CB"
          />
          <Radar
            name="Score"
            dataKey="value"
            stroke="#98495C"
            fill="#98495C"
            fillOpacity={0.35}
            strokeWidth={2}
          />
          <Tooltip
            contentStyle={{
              background: "white",
              border: "1px solid #EBD1CB",
              borderRadius: 12,
              fontFamily: "Manrope, sans-serif",
            }}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
